import setHistoryState from './setHistoryState';

/**
 * Compute the scroll to section id
 * @param sectionId - The section id
 * @param headerOffset - The header offset
 * @returns True if the section id was computed and scrolled to, false otherwise
 */
const computeScrollToSectionId = (sectionId: string, headerOffset: number) => {
  const element = document.getElementById(`${sectionId}-section`);

  if (!element) {
    return false;
  }

  setHistoryState(sectionId);

  // Sections are offset by 5px to account for the border
  const elementPosition =
    element.getBoundingClientRect().top + 5 + window.scrollY - headerOffset;
  const offsetPosition = elementPosition;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth'
  });

  return true;
};

export default computeScrollToSectionId;
